import React, { useState } from 'react';
import {
  FiPhone, FiPhoneOff, FiPhoneCall, FiMic, FiMicOff, FiGrid, FiUsers, FiUserPlus,
  FiX, FiDelete, FiRefreshCw, FiAlertTriangle, FiWifiOff, FiChevronUp, FiChevronDown,
  FiFileText, FiUser, FiSave,
} from 'react-icons/fi';
import { usePhone, AUDIO_ISSUE_TITLES, AUDIO_ISSUE_HINTS } from '../../phone/PhoneContext';
import { formatDuration } from '../../utils/formatters';
import DebtInfo from './DebtInfo';

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
const mmss = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

function Meter({ level, warn }) {
  return (
    <div className="op2-meter">
      <i style={{
        width: `${Math.round(Math.min(1, level || 0) * 100)}%`,
        background: warn ? 'var(--g-bad)' : level > 0.6 ? 'var(--g-warn)' : 'var(--g-ok)',
      }} />
    </div>
  );
}

// Telefon — ekran pastida suzuvchi "orol". Har doim ko'rinadi, lekin ish
// maydonini egallamaydi: bo'sh turganda bitta qator, qo'ng'iroqda o'sadi.
export default function PhoneIsland({ onSaveContact }) {
  const p = usePhone();
  const [open, setOpen] = useState(false);      // klaviatura/xodimlar ochiqmi
  const [tab, setTab] = useState('keypad');     // keypad | staff
  const [dtmf, setDtmf] = useState(false);      // suhbat paytidagi raqamlar

  // Qo'ng'iroq qilayotgan tashkilotning qarzi (kontaktga tashkilot biriktirilgan bo'lsa).
  const peerDebt = p.peerCard && p.peerCard.number === p.peerNumber ? p.peerCard.debt : null;

  // --- JIRINGLAYAPTI ---
  if (p.callState === 'incoming') {
    // "Yashirish" bosilgan: ovoz o'chgan, lekin qo'ng'iroq navbatda turibdi —
    // orol kichik chiziqqa yig'iladi va bosilsa qaytib ochiladi.
    if (p.incomingHidden) {
      return (
        <div
          className="op2-island g ring"
          style={{ width: 'min(380px, calc(100vw - 32px))', cursor: 'pointer' }}
          onClick={p.showIncoming}
          title="Qo'ng'iroqni qayta ochish"
        >
          <div className="op2-live">
            <span className="op2-inc-dot" />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="op2-live-n" style={{ fontSize: 15 }}>{p.contactName || p.peerNumber}</div>
              <div className="op2-live-s">kiruvchi qo'ng'iroq</div>
            </div>
            <span className="op2-inc-t" style={{ fontSize: 15 }}>{mmss(p.ringSeconds)}</span>
            <FiChevronUp size={19} />
          </div>
        </div>
      );
    }
    return (
      <div className="op2-island g ring">
        <div className="op2-live">
          <span className="op2-inc-dot" />
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="op2-inc-l">Kiruvchi qo'ng'iroq</div>
            <div className="op2-live-n">{p.contactName || p.peerNumber}</div>
            {p.contactName && <div className="op2-live-s">{p.peerNumber}</div>}
          </div>
          <span className="op2-inc-t">{mmss(p.ringSeconds)}</span>
        </div>
        <DebtInfo debt={peerDebt} compact />
        <div style={{ display: 'flex', gap: 9, marginTop: 12 }}>
          <button className="op2-btn go" style={{ flex: 1, padding: '14px 18px', fontSize: 15 }} onClick={p.answer}>
            <FiPhone size={18} /> Javob berish <span className="op2-kbd">Enter</span>
          </button>
          <button className="op2-btn stop" style={{ padding: '14px 18px' }} onClick={p.reject}>
            <FiPhoneOff size={18} /> Rad etish
          </button>
          <button
            className="op2-circle"
            onClick={p.hideIncoming}
            title="Yashirish — qo'ng'iroq rad etilmaydi, faqat ovoz o'chadi"
          >
            <FiX size={19} />
          </button>
        </div>
      </div>
    );
  }

  // --- SUHBAT / CHIQUVCHI ---
  if (p.inCall) {
    return (
      <div className="op2-island g wide">
        <div className="op2-live">
          <div style={{ minWidth: 0, flex: 1 }}>
            <div className="op2-inc-l" style={{ color: p.callState === 'active' ? 'var(--g-ok)' : 'var(--g-ac)' }}>
              {p.callState === 'outgoing' ? "Qo'ng'iroq qilinmoqda…" : 'Suhbat ketyapti'}
            </div>
            <div className="op2-live-n">{p.contactName || p.peerNumber}</div>
            {p.contactName && <div className="op2-live-s">{p.peerNumber}</div>}
          </div>
          {p.callState === 'active' && <span className="op2-live-t">{mmss(p.callDuration)}</span>}
          <div className="op2-live-a">
            <button
              className={`op2-circle${p.muted ? ' stop' : ''}`}
              onClick={p.toggleMute}
              title={p.muted ? 'Mikrofonni yoqish' : "Mikrofonni o'chirish"}
            >
              {p.muted ? <FiMicOff size={19} /> : <FiMic size={19} />}
            </button>
            {p.peerIsExternal && (
              <button
                className="op2-circle"
                onClick={() => p.openCard(p.peerNumber)}
                title="Mijoz kartasini ochish"
              >
                <FiUser size={19} />
              </button>
            )}
            {p.peerIsExternal && (
              <button
                className="op2-circle"
                onClick={onSaveContact}
                disabled={!!p.contactId}
                title={p.contactId ? 'Bu raqam allaqachon kontaktlarda bor' : 'Kontaktga saqlash'}
              >
                <FiUserPlus size={19} />
              </button>
            )}
            {p.callState === 'active' && (
              <>
                <button
                  className={`op2-circle${p.transferOpen ? ' on' : ''}`}
                  onClick={() => (p.transferOpen ? p.setTransferOpen(false) : p.openTransfer())}
                  disabled={p.transferring}
                  title="Boshqa operatorga o'tkazish"
                >
                  <FiUsers size={19} />
                </button>
                <button
                  className={`op2-circle${dtmf ? ' on' : ''}`}
                  onClick={() => setDtmf(!dtmf)}
                  title="Raqam yuborish (avtojavob uchun)"
                >
                  <FiGrid size={19} />
                </button>
              </>
            )}
            <button className="op2-circle stop big" onClick={p.hangup} title="Tugatish">
              <FiPhoneOff size={21} />
            </button>
          </div>
        </div>

        <DebtInfo debt={peerDebt} compact />

        {p.callState === 'active' && !p.muted && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginTop: 11 }}>
            <FiMic size={13} color={p.isMicIssue ? 'var(--g-bad)' : 'var(--g-tx3)'} />
            <Meter level={p.micLevel} warn={p.isMicIssue} />
          </div>
        )}

        {p.audioIssue && !p.muted && (
          <div className="op2-alert" style={{ color: p.isMicIssue ? 'var(--g-bad)' : 'var(--g-warn)' }}>
            <div className="op2-alert-t">
              <FiAlertTriangle size={13} style={{ verticalAlign: -2, marginRight: 6 }} />
              {AUDIO_ISSUE_TITLES[p.audioIssue] || AUDIO_ISSUE_TITLES.network}
            </div>
            {p.isMicIssue && (
              <>
                <div className="op2-alert-h">{AUDIO_ISSUE_HINTS[p.audioIssue]}</div>
                <button
                  className="op2-btn"
                  style={{ marginTop: 9, padding: '7px 12px', fontSize: 12 }}
                  onClick={() => (p.micPanelOpen ? p.closeMicPanel() : p.openMicPanel(false))}
                >
                  Mikrofonni almashtirish
                </button>
              </>
            )}
          </div>
        )}

        {/* Izohni GAPIRAYOTIB yozish: qo'ng'iroq tugashi bilan o'zi saqlanadi.
            Ish maydoni tegilmaydi — izoh telefon orolining o'zida. */}
        {p.callState === 'active' && p.peerIsExternal && (
          <div className="op2-note" style={{ marginTop: 12 }}>
            <div className="op2-quote-l" style={{ marginBottom: 6 }}>
              <FiFileText size={11} style={{ verticalAlign: -1, marginRight: 5 }} />
              Suhbat izohi — qo'ng'iroq tugashi bilan o'zi saqlanadi
            </div>
            <textarea
              style={{ minHeight: 62 }}
              value={p.liveNote}
              onChange={(e) => p.setLiveNote(e.target.value)}
              placeholder="Gaplashayotib yozib boring…"
            />
          </div>
        )}

        {p.micPanelOpen && (
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--g-br-2)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 9 }}>
              <span style={{ fontSize: 12.5, fontWeight: 700, flex: 1 }}>Mikrofon qurilmasi</span>
              <button className="op2-sm" onClick={p.closeMicPanel}><FiX size={14} /></button>
            </div>
            <div className="op2-list" style={{ maxHeight: 150 }}>
              {p.micDevices.length === 0 ? (
                <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Qurilma topilmadi</div>
              ) : p.micDevices.map((d) => (
                <button
                  key={d.deviceId}
                  className="op2-lrow"
                  style={d.deviceId === p.micDeviceId ? { borderColor: 'var(--g-ok)' } : undefined}
                  onClick={() => p.chooseMic(d.deviceId)}
                  disabled={p.micBusy}
                >
                  <span className="op2-lrow-n" style={{ fontWeight: 500, fontSize: 12.5 }}>{d.label}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {p.transferOpen && (
          <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--g-br-2)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 9 }}>
              <span style={{ fontSize: 12.5, fontWeight: 700, flex: 1 }}>Kimga o'tkazamiz?</span>
              <button className="op2-sm" onClick={() => p.setTransferOpen(false)}><FiX size={14} /></button>
            </div>
            {p.transferring ? <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>O'tkazilmoqda…</div>
              : p.transferLoading ? <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Yuklanmoqda…</div>
              : p.transferOps.length === 0 ? <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Hozir bo'sh operator yo'q</div>
              : (
                <div className="op2-list" style={{ maxHeight: 180 }}>
                  {p.transferOps.map((op) => (
                    <button key={op.id} className="op2-lrow" onClick={() => p.doTransfer(op)}>
                      <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--g-ok)', flexShrink: 0 }} />
                      <span className="op2-lrow-n">{op.full_name}</span>
                      <span className="op2-mono">{op.sip_extension}</span>
                    </button>
                  ))}
                </div>
              )}
          </div>
        )}

        {dtmf && p.callState === 'active' && (
          <>
            <div className="op2-keys">
              {KEYS.map((d) => (
                <button key={d} onClick={() => p.pressDigit(d)} style={{ padding: '11px 0', fontSize: 18 }}>{d}</button>
              ))}
            </div>
            <div style={{ fontSize: 11.5, color: 'var(--g-tx3)', marginTop: 8, textAlign: 'center' }}>
              Avtojavob menyusi uchun raqam yuborish
            </div>
          </>
        )}
      </div>
    );
  }

  // --- BO'SH ---
  return (
    <div className="op2-island g">
      {!p.registered && (
        <div
          className="op2-alert"
          style={{ color: 'var(--g-bad)', marginTop: 0, marginBottom: 11 }}
        >
          <div className="op2-alert-t">
            <FiWifiOff size={13} style={{ verticalAlign: -2, marginRight: 6 }} />
            Telefoniya ulanmagan — qo'ng'iroq qilib/qabul qilib bo'lmaydi
          </div>
          <div className="op2-alert-h">
            Sahifani yangilab ko'ring (Ctrl+Shift+R). O'zgarmasa administratorga ayting.
          </div>
        </div>
      )}

      {/* Qo'ng'iroq tugadi, izoh yozilmagan — orol ichida ixtiyoriy izoh.
          Majburiy emas: "Keyin" bosilsa yopiladi, jurnaldagi izoh tugmasi qoladi. */}
      {p.pendingNote && (
        <div className="op2-note" style={{ marginTop: 0, marginBottom: 12, paddingBottom: 12, borderBottom: '1px solid var(--g-br-2)' }}>
          <div className="op2-quote-l" style={{ marginBottom: 7, display: 'flex', alignItems: 'center', gap: 8 }}>
            <FiFileText size={11} />
            <span style={{ flex: 1 }}>
              Izoh · {p.pendingNote.name || p.pendingNote.number} · {formatDuration(p.pendingNote.durationSec)}
            </span>
            <button className="op2-sm" onClick={() => p.setPendingNote(null)} title="Yopish">
              <FiX size={14} />
            </button>
          </div>
          <textarea
            style={{ minHeight: 62 }}
            autoFocus
            value={p.pendingNote.text}
            onChange={(e) => p.setPendingNote({ ...p.pendingNote, text: e.target.value })}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); p.savePendingNote(); }
              if (e.key === 'Escape') { e.preventDefault(); p.setPendingNote(null); }
            }}
            placeholder="Nima haqida gaplashildi?"
          />
          <div style={{ display: 'flex', gap: 9, marginTop: 9 }}>
            <button className="op2-btn go" style={{ flex: 1 }} onClick={p.savePendingNote} disabled={!p.pendingNote.text.trim()}>
              <FiSave size={15} /> Izohni saqlash
            </button>
            <button className="op2-btn" onClick={() => p.setPendingNote(null)}>Keyin</button>
          </div>
        </div>
      )}

      {open && (
        <>
          <div className="op2-island-tabs">
            <button className={tab === 'keypad' ? 'on' : ''} onClick={() => setTab('keypad')}>
              <FiGrid size={14} /> Klaviatura
            </button>
            <button
              className={tab === 'staff' ? 'on' : ''}
              onClick={() => { setTab('staff'); p.loadStaff(); }}
            >
              <FiUsers size={14} /> Xodimlar
            </button>
          </div>

          {tab === 'keypad' ? (
            <div className="op2-keys" style={{ marginTop: 0, marginBottom: 12 }}>
              {KEYS.map((d) => (
                <button key={d} onClick={() => p.pressDigit(d)}>{d}</button>
              ))}
            </div>
          ) : (
            <div style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 8 }}>
                <span style={{ fontSize: 12, color: 'var(--g-tx3)', fontWeight: 700, flex: 1 }}>
                  Bo'sh xodimlar — ichki qo'ng'iroq
                </span>
                <button className="op2-sm" onClick={p.loadStaff} title="Yangilash"><FiRefreshCw size={13} /></button>
              </div>
              {p.staffLoading ? <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Yuklanmoqda…</div>
                : p.staff.length === 0 ? <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Hozir bo'sh xodim yo'q</div>
                : (
                  <div className="op2-list">
                    {p.staff.map((op) => (
                      <button
                        key={op.id}
                        className="op2-lrow"
                        onClick={() => p.dial(op.sip_extension, op.full_name)}
                        disabled={!p.registered}
                      >
                        <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--g-ok)', flexShrink: 0 }} />
                        <span className="op2-lrow-n">{op.full_name}</span>
                        <span className="op2-mono">{op.sip_extension}</span>
                        <FiPhoneCall size={14} color="var(--g-ok)" />
                      </button>
                    ))}
                  </div>
                )}
            </div>
          )}
        </>
      )}

      <div className="op2-dial">
        <button
          className={`op2-circle${open ? ' on' : ''}`}
          onClick={() => setOpen(!open)}
          title={open ? 'Yopish' : 'Klaviatura va xodimlar'}
        >
          {open ? <FiChevronDown size={20} /> : <FiChevronUp size={20} />}
        </button>
        <input
          value={p.dialNumber}
          onChange={(e) => p.setDialNumber(e.target.value.replace(/[^0-9*#+]/g, ''))}
          onKeyDown={(e) => { if (e.key === 'Enter') p.dial(p.dialNumber); }}
          placeholder="Raqam tering yoki ro'yxatdan bosing"
          inputMode="tel"
        />
        {p.dialNumber && (
          <button className="op2-circle" onClick={() => p.setDialNumber(p.dialNumber.slice(0, -1))} title="O'chirish">
            <FiDelete size={19} />
          </button>
        )}
        <button
          className="op2-circle go big"
          onClick={() => p.dial(p.dialNumber)}
          disabled={!p.registered || !p.dialNumber}
          title="Qo'ng'iroq qilish"
        >
          <FiPhoneCall size={21} />
        </button>
      </div>
    </div>
  );
}
